module.exports = __webpack_public_path__ + "static/media/capture_session_02.9acc29b0.png";